import { useEffect } from 'react';

// Criamos um evento personalizado para notificar sobre atualizações de logo de produtos
const WORKSPACE_LOGO_UPDATE_EVENT = 'workspace-logo-update';

// Interface para os dados do evento
interface WorkspaceLogoUpdateEventData {
  workspaceId: string;
  logoUrl: string;
  timestamp: number;
}

/**
 * Hook para emitir um evento de atualização de logo de produto
 */
export const useEmitWorkspaceLogoUpdate = () => {
  const emitWorkspaceLogoUpdate = (workspaceId: string, logoUrl: string) => {
    // Criamos um evento personalizado com os dados da atualização
    const event = new CustomEvent<WorkspaceLogoUpdateEventData>(WORKSPACE_LOGO_UPDATE_EVENT, {
      detail: {
        workspaceId,
        logoUrl,
        timestamp: Date.now()
      }
    });
    
    // Disparamos o evento no documento
    document.dispatchEvent(event);
    console.log('[useWorkspaceLogoEvent] Evento de atualização de logo de produto emitido:', { workspaceId, logoUrl });
  };

  return { emitWorkspaceLogoUpdate };
};

/**
 * Hook para escutar eventos de atualização de logo de produto
 * @param workspaceId ID do produto para filtrar (opcional)
 * @param callback Função a ser chamada quando o evento ocorrer
 */
export const useListenWorkspaceLogoUpdate = (
  workspaceId: string | undefined,
  callback: (data: WorkspaceLogoUpdateEventData) => void
) => {
  useEffect(() => {
    // Handler para o evento
    const handleWorkspaceLogoUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<WorkspaceLogoUpdateEventData>;
      const data = customEvent.detail;
      
      // Se um workspaceId foi especificado, filtramos os eventos
      if (workspaceId && data.workspaceId !== workspaceId) {
        return;
      }
      
      // Chamamos o callback com os dados do evento
      callback(data);
      console.log('[useWorkspaceLogoEvent] Evento de atualização de logo de produto recebido:', data);
    };
    
    // Registramos o listener
    document.addEventListener(WORKSPACE_LOGO_UPDATE_EVENT, handleWorkspaceLogoUpdate);
    
    // Limpeza ao desmontar
    return () => {
      document.removeEventListener(WORKSPACE_LOGO_UPDATE_EVENT, handleWorkspaceLogoUpdate);
    };
  }, [workspaceId, callback]);
};
